import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import { Dashboard } from "@/pages/Dashboard";
import { WeeklyTimesheet } from "@/pages/WeeklyTimesheet";
import { Entries } from "@/pages/Entries";
import { Approvals } from "@/pages/Approvals";
import { ClientBilling } from "@/pages/ClientBilling";
import { WorkOrders } from "@/pages/WorkOrders";
import { Projects } from "@/pages/Projects";
import { StaffEntries } from "@/pages/StaffEntries";
export function AppRoutes() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "/timesheet", element: _jsx(WeeklyTimesheet, {}) }), _jsx(Route, { path: "/entries", element: _jsx(Entries, {}) }), _jsx(Route, { path: "/staff-entries", element: _jsx(StaffEntries, {}) }), _jsx(Route, { path: "/approvals", element: _jsx(Approvals, {}) }), _jsx(Route, { path: "/billing", element: _jsx(ClientBilling, {}) }), _jsx(Route, { path: "/work-orders", element: _jsx(WorkOrders, {}) }), _jsx(Route, { path: "/projects", element: _jsx(Projects, {}) })] }));
}
